import * as Sentry from "@sentry/browser";

import { shouldSampleReplay } from "./replay_error_filter";

if (import.meta.env.PROD) {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    environment: import.meta.env.VITE_DEPLOY_ENV,
    release: import.meta.env.VITE_RELEASE_VERSION,

    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false,
        // Which errors are worth spending one of the period's 50
        // replays on. Kept as its own module because this file
        // only runs under import.meta.env.PROD and so cannot be
        // unit tested; the reasoning, the issue-by-issue list and
        // the SDK contract it was written against all live there,
        // with the spec beside it. It returns true for everything
        // it does not recognise, ours included (CAL-504).
        beforeErrorSampling: shouldSampleReplay,
      }),
    ],

    // Fraction of page loads and navigations traced from the
    // browser. Was 0.3; lowered to 0.1 in CAL-504, for two
    // reasons.
    //
    // The browser is a sixth of all span volume on its own, and
    // most of it is resource.img — one span per menu photo per
    // sampled visit, 294k of them a week — which tells us nothing
    // a slow-page complaint wouldn't.
    //
    // The bigger reason is that this number was never only the
    // browser's. A browser trace propagates its sampling decision
    // to our server through the traceparent header
    // (tracePropagationTargets below), and the server's
    // traces_sampler honours an inherited parent_sampled before it
    // ever reaches its own rates (config/initializers/sentry.rb).
    // So this rate, not the server's 0.2, was what customer menu
    // and checkout requests were actually traced at: the one
    // number we tuned server-side was being overridden by a
    // number set in a different file for a different purpose.
    // 0.1 keeps the browser side under the server's own web rate,
    // so a page load can no longer buy itself more server tracing
    // than a request that starts at the server.
    // Learn more at
    // https://docs.sentry.io/platforms/javascript/configuration/options/#traces-sample-rate
    tracesSampleRate: 0.1,

    // Set `tracePropagationTargets` to control for which URLs trace propagation should be enabled
    tracePropagationTargets: [/^https:\/\/(?:[\w-]+\.)*calisto\.ai$/],

    // No replay for an ordinary session; a replay for every
    // session that throws an error the filter above keeps. The
    // 1.0 stays deliberately: an error worth watching is worth
    // watching every time it happens, and the quota is now spent
    // on WHICH errors qualify (beforeErrorSampling) rather than
    // on a dice roll that would thin our own bugs and the browser
    // noise in equal proportion (CAL-504).
    // Learn more at
    // https://docs.sentry.io/platforms/javascript/session-replay/configuration/#general-integration-configuration
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 1.0,
  });

  Sentry.setUser({
    id: document.querySelector("meta[name='current_employee_id']")?.content,
    email: document.querySelector("meta[name='current_employee_email']")
      ?.content,
  });
}
